/**
 * 创建分类弹窗
 * Bai.Zhiming
 * 2019-6-18
 */
angular.module('hCreateClassifyModule', []).
controller('hCreateClassifyCtrl', ["$scope", "parentclassify", "$validation", "$modalInstance", function($scope, parentclassify, $validation, $modalInstance) {
    $scope.confirm = function() {
        $validation.validate($scope.theForm).success(() => {
            $modalInstance.close(angular.copy($scope.data));
        });
    }
    $scope.cancel = function() {
        $modalInstance.dismiss();
    }
    initStatus();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            isCreate: angular.isUndefined(parentclassify)
        };
        $scope.data = {
            parentclassify: parentclassify
        };
    }
}]);